<template>
  <div>
      <div class="columns">
        <div class="column" style="overflow-x: auto;" v-if="!isLoading">
          <bar-label-chart slot="content"  class="dynamic-chart" :style="{ 'min-width':  '100%','width': dynamicWidthChart }" v-if="!isLoading"
          :chart-data="defaultChart.chartData" :extra-options="defaultChart.extraOptions"
          @on-receive="clickOnChart"
          ></bar-label-chart>
        </div>
        <div class="column" style="min-height: 200px;" v-else>
          <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
        </div>
      </div>
  </div>
</template>

<script>
import * as chartConfig from '@/components/Charts/chart.config'
import BarLabelChart from '@/components/Charts/BarLabelChart'
import TenantService from '@/services/TenantService.js'

import colorsList from '@/utils/colorsList'

export default {
  components: {
    BarLabelChart
  },
  props: {
    selectedHorses: {
      type: Array,
      default: () => []
    },
    from: {
      required: false,
      default: null
    },
    to: {
      required: false,
      default: null
    },
    lesson: {
      required: true
    }
  },
  created () {
    this.getHorsesFromLessons()
  },
  data () {
    return {
      horses: [],
      defaultChart: {
        chartData: {},
        extraOptions: {
          ...chartConfig.chartOptionsMain,
          scales: {
            yAxes: [{
              ticks: {
                max: 10,
                min: 0,
                stepSize: 1
              }
            }],
            xAxes: [{
              ticks: {
                callback: function (value, index, values) {
                  return value[1]
                }
              }
            }]
          },
          legend: {
            display: true
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label || ''
                if (label) {
                  label += ' : '
                }
                label += tooltipItem.yLabel
                return label
              },
              title: function (tooltipItem, data) {
                var label = tooltipItem[0].xLabel[1] || ''
                return label
              }
            }
          }
        }
      },
      isLoading: false,
      labels: [],
      scores: [],
      colorsArr: colorsList
    }
  },
  methods: {
    clickOnChart (event) {
      let selectedHorse = this.horses.find((x) => x.name === event.label)
      let selectedExercise = event.xAxes
      this.$emit('bar-clicked', {
        horse: selectedHorse,
        exercise: selectedExercise,
        color: event.color
      })
    },
    async getHorsesFromLessons () {
      if (this.lesson === 0 || this.lesson == null) {
        return false
      }
      this.isLoading = true
      let params = {
        from: this.from,
        to: this.to,
        lesson_id: this.lesson,
        exercises: true,
        horses: this.selectedHorses.map((x) => x.id)
      }
      let response = await TenantService.getLessonComparison(params)
      this.horses = response.data.data.filter((horse) => {
        if (horse.exercises.length > 0) {
          return true
        }
      })
      this.initChartData()
      this.isLoading = false
    },
    initChartData () {
      let horsesDataSets = this.mapDataSets()
      let mapLabels = this.mapLabels()

      this.defaultChart.chartData = {
        datasets: horsesDataSets,
        labels: mapLabels
      }
    },
    mapDataSets () {
      let dataSets = []
      for (let index = 0; index < this.horses.length; index++) {
        let horse = this.horses[index]
        dataSets[index] = {
          label: horse.name,
          data: horse.exercises.map((x) => x.baseScore.toFixed(2)),
          maxBarThickness: 15,
          backgroundColor: this.colorsArr[index],
          datalabels: {
            display: true,
            align: 'top',
            offset: 5,
            anchor: 'end',
            borderRadius: 3,
            color: 'black',
            rotation: 75,
            font: {
              size: 12
            }
          }
        }
      }
      return dataSets
    },
    mapLabels () {
      return this.horses[0] ? this.horses[0].exercises.map((x) => [x.id, x.name]) : []
    }
  },
  watch: {
    selectedHorses (value) {
      this.getHorsesFromLessons()
    },
    lesson (value) {
      this.getHorsesFromLessons()
    },
    from (value) {
      this.getHorsesFromLessons()
    },
    to (value) {
      this.getHorsesFromLessons()
    }
  },
  computed: {
    dynamicWidthChart () {
      return `${this.horses.length * 400}px`
    }
  }

}
</script>

<style scoped>
  .dynamic-chart{
    height: 300px !important;
    min-height: 250px !important;
  }

  .tags-container{
    padding-top: 3rem;
  }
</style>
